// @flow

import * as React from "react"
import Tooltip from "rc-tooltip"
import ClassNames from "classnames"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import {
  hasProductSetProductsOnBabyList,
  getBabyListItemFromBabyListItem,
  // getBabyListItem,
  getBabyListItemByProduct,
  isProductOnBabyList,
  // isProductInShop,
} from "../reducers/baby"
import {
  getOptionalByProduct,
  isProductToggled,
  isProductRevealed,
} from "../reducers/products"
import {
  toggleProduct,
  getProductSetMedia,
  getProductMedia,
  clearMedia,
} from "../actions/products"
import Icon from "./icon"
import ProductListItemSettings from "./product-list-item-settings"
import MediaViewer from "./media-viewer"
import PriceTag from "./price-tag"
import type {
  Dispatch,
  ProductSet,
  ProductOrSet,
  ProductMedia,
  BabyList,
  BabyListItem,
  BabyListOptionalItem,
  State as ReduxState,
} from "../types"

type Props = {
  +t: any,
  +dispatch: Dispatch,
  +isSummary: boolean,
  +product: ProductOrSet,
  +toggleds: $ReadOnlyArray<ProductOrSet>,
  +revealeds: $ReadOnlyArray<ProductOrSet>,
  +amount: ?number,
  +media: $ReadOnlyArray<ProductMedia>,
  +productSet: ?ProductSet,
  +babyList: BabyList,
  +optionals: $ReadOnlyArray<BabyListOptionalItem>,
  +onAddToBabyList: (ProductOrSet, ?ProductSet) => void,
  +onRemoveFromBabyList: (number) => void,
  +onAddOptional: (ProductOrSet) => void,
  +onUpdateBabyListItem: (BabyListItem) => void,
  +onRemoveOptional: (number) => void,
  +hasFocus: boolean,
}

type State = {
  toggled: boolean,
  jump: boolean,
  showMedia: boolean,
}

class ProductListItem extends React.Component<Props, State> {
  handleAdd: (ProductOrSet, ?ProductSet) => void
  handleRemove: (number) => void
  handleAddOptional: (ProductOrSet) => void
  handleRemoveOptional: (number) => void
  handleUpdateBabyListItem: (BabyListItem) => void
  handleToggleSettings: () => void
  handleShowMedia: () => void
  handleHideMedia: () => void

  el: any

  static defaultProps = {
    hasFocus: false,
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      toggled: false,
      jump: false,
      showMedia: false,
    }

    this.handleAdd = this.handleAdd.bind(this)
    this.handleRemove = this.handleRemove.bind(this)
    this.handleAddOptional = this.handleAddOptional.bind(this)
    this.handleRemoveOptional = this.handleRemoveOptional.bind(this)
    this.handleUpdateBabyListItem = this.handleUpdateBabyListItem.bind(this)
    this.handleToggleSettings = this.handleToggleSettings.bind(this)
    this.handleShowMedia = this.handleShowMedia.bind(this)
    this.handleHideMedia = this.handleHideMedia.bind(this)
  }

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (
      isProductToggled(nextProps.toggleds, nextProps.product) &&
      !prevState.toggled
    ) {
      return {
        toggled: true,
        jump: nextProps.productSet ? false : true,
      }
    }
    return {
      toggled: isProductToggled(nextProps.toggleds, nextProps.product),
      jump: false,
    }
  }

  handleAdd(product: ProductOrSet, productSet: ?ProductSet) {
    this.props.onAddToBabyList(product, productSet)
  }

  handleRemove(babyListItemId) {
    this.props.onRemoveFromBabyList(babyListItemId)
  }

  handleAddOptional(product: ProductOrSet) {
    this.props.onAddOptional(product)
  }

  handleRemoveOptional(optionalId: number) {
    this.props.onRemoveOptional(optionalId)
  }

  handleUpdateBabyListItem(babyListItem: BabyListItem) {
    this.props.onUpdateBabyListItem(babyListItem)
  }

  handleToggleSettings() {
    const {dispatch, product} = this.props
    dispatch(toggleProduct(product))
  }

  handleShowMedia(e) {
    e.preventDefault()
    e.stopPropagation()

    const {product, dispatch} = this.props
    if (product.isSet) {
      dispatch(getProductSetMedia(product.id))
    } else {
      dispatch(getProductMedia(product.id))
    }
    this.setState({showMedia: true})
  }

  handleHideMedia() {
    this.props.dispatch(clearMedia())
    this.setState({showMedia: false})
  }

  componentDidUpdate(/*prevProps: Props*/) {
    if (this.state.jump) {
      this.setState({jump: false})
      setTimeout(() => {
        this.scrollVisible()
      }, 200)
    }
  }

  scrollVisible() {
    const doc = document.documentElement
    if (!doc || !this.el) {
      return
    }
    const windowTop =
      (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
    const {top: holderTop, height: holderHeight} =
      this.el.getBoundingClientRect()
    const holderSum = holderTop + windowTop + holderHeight
    if (holderHeight >= window.innerHeight) {
      // In case we have very large item
      window.scrollTo(0, windowTop + holderTop)
    } else if (holderSum > window.innerHeight + windowTop) {
      // Out of screen, bottom
      window.scrollTo(0, holderSum - window.innerHeight + 20)
    } else if (holderTop + windowTop - 80 < windowTop) {
      // Out of screen, top
      window.scrollTo(
        0,
        windowTop + holderTop - 20 - 80 /* sticky header height */
      )
    }
  }

  renderRemoveButton(babyListItem: BabyListItem) {
    return (
      <button
        className="btn btn-outline-primary product-list-item-add-remove-btn is-active is-remove"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          this.handleRemove(babyListItem.id)
          return false
        }}
      />
    )
  }

  renderAddButton(product: ProductOrSet, productSet: ?ProductSet) {
    return (
      <button
        className="btn btn-outline-primary product-list-item-add-remove-btn"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          this.handleAdd(product, productSet)
          return false
        }}
      />
    )
  }

  renderAddRemoveButton() {
    // productSet is null when on top level
    const {babyList, product, productSet} = this.props
    // const babyListItem = getBabyListItem(product, babyList, productSet)

    const babyListItem = this.getBabyListItem()

    // if (product.name != "Bugaboo Cameleon buggyset") return null

    // console.log("--------")

    // if (product.name == "Opbergmand speelgoed recupstof Maxi") {
    //   console.log("renderAddRemoveButton", product, babyList)
    // }
    // if (babyListItem && isProductInShop(product, babyList, babyListItem)) {
    //   return this.renderAddButton(product, productSet)
    // }

    // if is set and set is on babylist
    // -> remove set
    if (product.isSet && babyListItem) {
      // console.info("isset and babyListItem")
      return this.renderRemoveButton(babyListItem)
    }

    // if is set and item from set is on babylist (divisible)
    // -> no button
    if (product.isSet && hasProductSetProductsOnBabyList(product, babyList)) {
      // console.info( "isset and if is set and item from set is on babylist (divisible)", product.name)
      return null
    }

    // if is single product and on babylist
    // -> remove button
    if (
      !product.isSet &&
      babyListItem &&
      !productSet &&
      babyListItem.productSetId == null
    ) {
      // console.info("if is single product and on babylist", product.name)
      return this.renderRemoveButton(babyListItem)
    }

    // if is product in set and set is on babylist
    // -> no button
    if (
      !product.isSet &&
      productSet &&
      getBabyListItemByProduct(productSet, babyList)
    ) {
      // console.info("if is product in set and set is on babylist", product.name)
      return null
    }

    // if is product in set and set is not on babylist
    // -> remove button
    if (
      !product.isSet &&
      productSet &&
      !getBabyListItemByProduct(productSet, babyList) &&
      babyListItem &&
      babyListItem.productSetId == productSet.id
    ) {
      return this.renderRemoveButton(babyListItem)
    }

    // if not set but in set and set is not divisble
    if (!product.isSet && productSet && !productSet.isDivisible) {
      // console.info( "if not set but in set and set is not divisble", product.name)
      return null
    }

    // if set
    if (product.isSet) {
      // console.info("if set", product.name, product)
      return this.renderAddButton(product, productSet)
    }

    // console.info("add")
    // if single product
    return this.renderAddButton(product, productSet)
  }

  renderAddRemoveOptionalButton() {
    const {product, productSet, optionals} = this.props
    if (productSet && !productSet.isDivisible) {
      return null
    }
    const optional = getOptionalByProduct(optionals, product)
    const className = ClassNames("product-list-item-optional", {
      "is-active": optional ? true : false,
    })
    return (
      <span
        onClick={(e) => {
          e.preventDefault()
          optional
            ? this.handleRemoveOptional(optional.id)
            : this.handleAddOptional(product)
          return false
        }}
        className={className}
      >
        <Icon name="icon-pulse" />
      </span>
    )
  }

  renderIconStub() {
    return <span className="set-icon is-stub" />
  }

  renderSetIcon() {
    const {product} = this.props
    if (!product.isSet) {
      return this.renderIconStub()
    }
    return (
      <span className="set-icon">
        <Icon name={`icon-${product.isDivisible ? "set-divisible" : "set"}`} />
      </span>
    )
  }

  renderProductSetProducts() {
    const {
      product: productSet,
      babyList,
      optionals,
      isSummary,
      toggleds,
      revealeds,
      media,
      t,
      dispatch,
    } = this.props
    if (!productSet.isSet || !this.state.toggled) {
      return
    }
    return (
      <ul className="product-list-item-products product-list">
        {productSet.products
          .filter(
            (product) =>
              !product.product.isHidden ||
              isProductOnBabyList(product.product, babyList) ||
              isProductRevealed(revealeds, product.product)
          )
          .map((product) => (
            <ProductListItem
              key={product.id}
              t={t}
              dispatch={dispatch}
              babyList={babyList}
              optionals={optionals}
              toggleds={toggleds}
              revealeds={revealeds}
              product={product.product}
              media={media}
              amount={product.amount}
              productSet={productSet}
              onAddToBabyList={this.handleAdd}
              onRemoveFromBabyList={this.handleRemove}
              onAddOptional={this.handleAddOptional}
              onRemoveOptional={this.handleRemoveOptional}
              onUpdateBabyListItem={this.handleUpdateBabyListItem}
              isSummary={isSummary}
            />
          ))}
      </ul>
    )
  }

  renderSettings() {
    const {product, productSet /*, babyList*/} = this.props
    let babyListItem = this.getBabyListItem()
    if (!this.state.toggled) {
      // isProductToggled(toggleds, product)) {
      return null
    }
    // if (isProductInShop(product, babyList, babyListItem)) {
    //   return null
    // }
    return (
      <ProductListItemSettings
        babyListItem={babyListItem}
        product={product}
        productSet={productSet}
        onUpdate={this.handleUpdateBabyListItem}
      />
    )
  }

  renderHeader() {
    const {product} = this.props
    return (
      <div className="product-list-item-header">
        {this.renderSetIcon()}
        <div>
          <h2>
            {product.name} <span className="subname">{product.subname}</span>
          </h2>
        </div>
      </div>
    )
  }

  getBabyListItem() {
    const {product, productSet, babyList} = this.props
    let babyListItem = getBabyListItemByProduct(product, babyList)
    // When we are rendering a child product from a set, where the set is added
    // babyListItem will be null, but if we look for the set babyListItem, we should
    // find the child products in the items from the set babyListItem

    if (
      !babyListItem &&
      !product.isSet &&
      productSet &&
      productSet.isDivisible
    ) {
      const setBabyListItem = getBabyListItemByProduct(productSet, babyList)
      if (setBabyListItem) {
        babyListItem = getBabyListItemFromBabyListItem(product, setBabyListItem)
      }
    }

    // const inShop = isProductInShop(product, babyList, babyListItem)
    // console.log(inShop, babyListItem)
    // if (inShop) {
    //   return null
    // }
    // console.log(babyListItem)
    // if (babyListItem && babyListItem.isOnInvoice) return null
    return babyListItem
  }

  getAmount() {
    const {product, amount} = this.props
    let babyListItem = this.getBabyListItem()

    const item = babyListItem ? babyListItem : product
    let showAmount = 0
    if (babyListItem) {
      showAmount = babyListItem.amount
    } else if (amount !== undefined && amount !== null) {
      showAmount = amount
    } else {
      showAmount = item.babyListId ? item.amount : item.typicalAmount
    }

    return showAmount
  }

  renderAmount() {
    const {t} = this.props
    return <>{t("intake.products.amount", {amount: this.getAmount()})}</>
  }

  render() {
    const {
      product,
      productSet,
      // hasFocus,
      babyList,
      media,
      isSummary,
    } = this.props
    const {toggled} = this.state
    const babyListItem = this.getBabyListItem()
    const item = babyListItem ? babyListItem : product
    const pClass = product.isSet ? `ps${product.id}` : `p${product.id}`
    const className = ClassNames("product-list-item " + pClass, {
      "is-summary-item": isSummary,
      "is-set": product.isSet,
      "has-focus": toggled,
      // 'is-in-shop': isProductInShop(product, babyList, babyListItem),
      "is-added": isAdded(babyListItem, babyList, product, productSet),
    })
    return (
      <li className={className} ref={(el) => (this.el = el)}>
        <div
          className="product-list-item-main-bar"
          onClick={this.handleToggleSettings}
        >
          <div className="product-list-item-main-actions">
            {this.renderAddRemoveButton()}
            {this.renderAddRemoveOptionalButton()}
            {this.renderSetIcon()}
          </div>

          <div className="product-list-item-data">
            <div className="product-list-item-desc">
              <h2>
                {product.name}{" "}
                <span className="subname">{product.subname}</span>
              </h2>
            </div>
            <div className="product-list-item-meta">
              {product.hasMedia ? (
                <span className="set-icon" onClick={this.handleShowMedia}>
                  <Icon name="icon-camera" />
                </span>
              ) : (
                this.renderIconStub()
              )}
              {product.remarks && product.remarks != "" ? (
                <Tooltip
                  mouseEnterDelay={0.3}
                  mouseLeaveDelay={0.3}
                  overlay={product.remarks}
                >
                  <span className="set-icon">
                    <Icon name="icon-information-white" />
                  </span>
                </Tooltip>
              ) : (
                this.renderIconStub()
              )}
            </div>
            <div className="product-list-item-amount">
              {this.renderAmount()}
            </div>
            <div className="product-list-item-price">
              <PriceTag item={item} amount={this.getAmount()} />
            </div>
          </div>
        </div>
        <div className="product-list-item-sub-bar">
          {this.renderSettings()}
          {product.isSet ? this.renderProductSetProducts() : null}
        </div>
        {this.state.showMedia ? (
          <MediaViewer media={media} onClose={this.handleHideMedia} />
        ) : null}
      </li>
    )
  }
}

const isAdded = (babyListItem, babyList, product, productSet) => {
  // set on babylist
  if (product.isSet && babyListItem && !babyListItem.isInShop) {
    return true
  }

  // set with sub products on babylist
  // if (product.isSet && hasProductSetProductsOnBabyList(product, babyList)) {
  //   return true
  // }

  if (
    babyListItem &&
    babyListItem.productSetId == null &&
    !babyListItem.isInShop &&
    !babyListItem.isOnInvoice
  ) {
    return true
  }

  if (
    babyListItem &&
    productSet &&
    babyListItem.productSetId == productSet.id &&
    !babyListItem.isInShop
  ) {
    return true
  }

  return false
}

const mapStateToProps = (state: ReduxState): any => ({
  babyList: state.baby.list,
  optionals: state.baby.optionals,
  toggleds: state.products.toggleds,
  revealeds: state.products.revealeds,
  media: state.products.entities.media,
})

export default withTranslation()(connect(mapStateToProps)(ProductListItem))
